import { useEffect, useRef, useState } from 'react'

export const useProfilePopoverMaxHeight = (isOpen: boolean, limitTo: number | null = 500) => {
  const [maxHeight, setMaxHeight] = useState(0)
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (containerRef.current) {
      const yTop = containerRef.current.getBoundingClientRect().top
      const height = window.innerHeight - yTop - 20
      setMaxHeight(limitTo ? Math.min(limitTo, height) : height)
    }
  }, [isOpen, limitTo])

  return { maxHeight, containerRef }
}
